import { Button } from "@progress/kendo-react-buttons";
import { TextBoxChangeEvent } from "@progress/kendo-react-inputs";
import { Drawer, DrawerContent } from "@progress/kendo-react-layout";
import { X } from "lucide-react";
import { useState } from "react";
import BBSTextField from "../../component/inputs/BBSTextField";
import { IObjectType } from "../../interfaces/objectType.interface";

interface IProps {
  showCreateDrawer: boolean;
  setShowCreateDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  addNewObjectType: (IObjectType & { id: string }) | null;
  handleChange: (e: TextBoxChangeEvent) => void;
  onSave: () => void;
}

function WriteDrawer({
  showCreateDrawer,
  setShowCreateDrawer,
  addNewObjectType,
  handleChange,
  onSave,
}: IProps) {
  const [invalidFields, setInvalidFields] = useState<{
    [key: string]: boolean;
  }>({});

  const handleValidation = (name: string, isValid: boolean) => {
    setInvalidFields((prev: any) => ({
      ...prev,
      [name]: !isValid,
    }));
  };

  const validateSave = () => {
    return Object.values(invalidFields).every((field) => !field);
  };

  return (
    <Drawer
      expanded={showCreateDrawer}
      position={"start"}
      mode={"overlay"}
      animation={{ duration: 400 }}
      className="customDrawer transition-all duration-500"
    >
      <DrawerContent>
        <div
          className="overlay"
          onClick={() => setShowCreateDrawer(false)}
        ></div>
        <div
          className={`max-w-[400px] flex flex-col bg-neutral-10 px-4 fixed right-0 top-0 bottom-0 h-full w-full transform transition-all duration-500 ${
            showCreateDrawer ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="py-4 flex items-center justify-between gap-2 border-b border-neutral-30">
            <h2 className="font-medium text-lg">
              {addNewObjectType?.id
                ? "Edit Object Type"
                : "Add New Object Type"}
            </h2>
            <Button
              fillMode="flat"
              className="p-2 bg-none outline-none"
              onClick={() => setShowCreateDrawer(false)}
            >
              <X className="w-4 h-4" />
            </Button>
          </div>
          <div className="flex-1 py-4">
            <div className="grid gap-4">
              <div>
                <BBSTextField
                  name="code"
                  value={addNewObjectType?.code}
                  onChange={handleChange}
                  onValidate={handleValidation}
                  label="Code"
                  required={true}
                  placeholder="Enter Code"
                  disabled={false}
                  regex={/[0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/}
                  error="Invalid Code"
                />
              </div>
              <div>
                <BBSTextField
                  name="name"
                  value={addNewObjectType?.name}
                  onChange={handleChange}
                  onValidate={handleValidation}
                  label="Name"
                  required={true}
                  placeholder="Enter Name"
                  disabled={false}
                  regex={/[0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/}
                  error="Invalid Name"
                />
              </div>
            </div>
          </div>
          <div className="flex justify-end gap-2 pb-4">
            <Button
              className="border border-[#E2E8F0]"
              onClick={() => setShowCreateDrawer(false)}
            >
              Cancel
            </Button>
            <Button
              className="border border-[#E2E8F0]"
              themeColor={"primary"}
              onClick={onSave}
              disabled={!validateSave()}
            >
              Save
            </Button>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}

export default WriteDrawer;
